// extracted by mini-css-extract-plugin
module.exports = {"Description":"Description__11bpQ"};